import type { Stage } from '../../shared/pack/schema'
import type { TripClock } from './tripClock'

export type StageStatus = 'done' | 'now' | 'next' | 'later'

/** Each stage relative to today: done, now, the next one, or later. */
export function stageStatuses(stages: Stage[], clock: TripClock): StageStatus[] {
  if (clock.phase === 'after') return stages.map(() => 'done')
  const nowIdx = clock.phase === 'during' ? clock.stageIndex : -1
  const nextIdx = nowIdx + 1
  return stages.map((_, i) => (i < nowIdx ? 'done' : i === nowIdx ? 'now' : i === nextIdx ? 'next' : 'later'))
}
